import React, { useState } from 'react';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { Button } from 'ui';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import RecordingQuestionResponses from './RecordingQuestionResponses';
import DeleteErrorModal from './shared/DeleteErrorModal';
import ConfirmDeleteModal from './shared/ConfirmDeleteModal';
import ShareableLink from './shared/ShareableLink';

const TAB_RECORD = 'record';

const MyResponsesTab = props => {
  const {
    data,
    userResponses,
    currentChoice,
    setCurrentChoice,
    setUserResponses,
    setSelectedTab,
    setIsTabDisabled,
    isWrittenQuestion,
    isRecordingQuestion,
    skipped,
    setSkipped,
    technicalDifficultiesReported,
    resetAnswer,
  } = props;

  const [userResponseToDelete, setUserResponseToDelete] = useState(null);
  const [showDeleteErrorModal, setShowDeleteErrorModal] = useState(false);

  const showDeleteModal = !!userResponseToDelete;

  const handlePracticeAgain = e => {
    e.preventDefault();
    setSelectedTab(TAB_RECORD);
  };

  const handleOptionsChange = e => {
    const { value } = e.target;

    const selected = userResponses.find(
      userResponse => userResponse.givenAnswer === value,
    );
    request
      .post(routes.PROMOTE_TO_ANSWER(data.lessonId, selected.id))
      .then(response =>
        setCurrentChoice(
          userResponses.find(
            userResponse => userResponse.id === response.selectedAttemptId,
          ),
        ),
      )
      .catch(error => {
        console.error(error);
        // TODO: Handle Server Error
      });
  };

  const handleDelete = attemptId => {
    const remainingResponses = userResponses.filter(
      userResponse => userResponse.id !== attemptId,
    );
    request
      .delete(
        routes.LESSON_REMOVE_ATTEMPT(data.lessonId, attemptId, data.questionId),
      )
      .then(response => {
        if (response.attempts.length === 0) {
          setUserResponseToDelete(null);
          setUserResponses(remainingResponses);
          setIsTabDisabled(true);
          setSelectedTab(TAB_RECORD);
          setCurrentChoice(null);
          resetAnswer();
        } else if (
          response.attempts.find(
            attempt =>
              attempt.isAnswer === true &&
              attempt.progressId === data.progressId,
          )
        ) {
          setCurrentChoice(
            response.attempts.find(
              attempt =>
                attempt.isAnswer === true &&
                attempt.progressId === data.progressId,
            ),
          );
          setUserResponses(response.attempts);
          setUserResponseToDelete(null);
        } else {
          setUserResponseToDelete(null);
          setUserResponses(response.attempts);
          setSelectedTab(TAB_RECORD);
          setCurrentChoice(null);
          resetAnswer();
        }
      })
      .catch(error => {
        setUserResponseToDelete(null);
        setShowDeleteErrorModal(true);
        console.error(error);
      });
  };
  const practiceAgainButtonDisabled = userResponses.length === 10;

  return (
    <>
      {showDeleteModal && (
        <ConfirmDeleteModal
          onDismiss={() => setUserResponseToDelete(null)}
          handleDelete={handleDelete}
          userResponseId={userResponseToDelete}
        />
      )}
      {showDeleteErrorModal && (
        <DeleteErrorModal
          closeDeleteErrorModal={() => setShowDeleteErrorModal(false)}
        />
      )}
      <div>
        {isRecordingQuestion && (
          <div>
            <RecordingQuestionResponses
              handleOptionsChange={handleOptionsChange}
              currentChoice={currentChoice}
              setUserResponseToDelete={setUserResponseToDelete}
              resetAnswer={resetAnswer}
              skipped={skipped}
              setSkipped={setSkipped}
              technicalDifficultiesReported={technicalDifficultiesReported}
              {...props}
            />
            {!data.isGradable && currentChoice && (
              <ShareableLink
                progressId={data.progressId}
                questionId={data.questionId}
                currentChoice={currentChoice}
              />
            )}
            <div className="d-f fd-c ai-c mb-32 ta-c">
              <Text variant={TEXT_VARIANTS.TITLE_BOLD} className="mt-32">
                {t('practice.repeatability.response_practice_title')}
              </Text>
              <Text variant={TEXT_VARIANTS.SUBHEADER} className="mb-16">
                {t('practice.repeatability.response_practice_subtitle')}
              </Text>
              <Button
                type="button"
                customColor
                disabled={practiceAgainButtonDisabled}
                onClick={e => handlePracticeAgain(e)}
                loading={false}
              >
                {t('practice.repeatability.practice_again_button')}
              </Button>
            </div>
          </div>
        )}
        {isWrittenQuestion && <div>Written Responses</div>}
      </div>
    </>
  );
};

export default MyResponsesTab;
